<template>
  <v-menu bottom :offset-y="false" left eager transition="slide-y-transition">
    <template v-slot:activator="{ on }">
      <v-btn dark icon v-on="on">
        <v-icon>mdi-share-variant</v-icon>
      </v-btn>
    </template>
    <v-list dark>
      <v-list-item
        class="social_share"
        data-type="fb"
        :data-title="title"
        style="cursor: pointer"
      >
        <v-icon>mdi-facebook</v-icon> <span class="pl-3">Facebook</span>
      </v-list-item>
      <v-list-item
        class="social_share"
        data-type="twitter"
        :data-title="title"
        style="cursor: pointer"
      >
        <v-icon>mdi-twitter</v-icon><span class="pl-3">Twitter</span>
      </v-list-item>
      <v-list-item
        class="social_share"
        data-type="pinterest"
        :data-title="title"
        style="cursor: pointer"
      >
        <v-icon>mdi-pinterest</v-icon><span class="pl-3">Pinterest</span>
      </v-list-item>
      <v-list-item
        class="social_share"
        data-type="whatsapp"
        :data-title="title"
        style="cursor: pointer"
      >
        <v-icon>mdi-whatsapp</v-icon><span class="pl-3">WhatsApp</span>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import JSShare from "js-share";
export default {
  name: "PhotoSocialShare",
  props: {
    title: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      const shareItems = document.querySelectorAll(".social_share");
      for (let i = 0; i < shareItems.length; i += 1) {
        shareItems[i].addEventListener("click", function share() {
          return JSShare.go(this);
        });
      }
    });
  }
};
</script>

<style scoped></style>
